var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 995,
    viewBox: "0 0 1920 995",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6175_5002)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1363.25 240.4L1503.56 483.228L1363.25 726L1223 483.228L1363.25 240.4Z",
    fill: "url(#paint0_linear_6175_5002)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1501.46 1.27173H1781.97L1920.18 240.405L1779.87 483.232H1503.56L1641.71 244.044L1501.46 1.27173Z",
    fill: "url(#paint1_linear_6175_5002)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.25 240.4L1427.64 351.889L1363.25 463.323L1298.86 351.889L1363.25 240.4Z",
    fill: "url(#paint2_linear_6175_5002)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1781.47 0L1920.18 240.401L1779.87 483.229L1641.72 244.04L1781.47 0Z",
    fill: "url(#paint3_linear_6175_5002)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.982 667L331 824.018L239.982 981L149 824.018L239.982 667Z",
    fill: "url(#paint4_linear_6175_5002)",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_6175_5002)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.573 719.675L203.612 793.246L202.039 796L160 722.433L161.573 719.675ZM197.961 656L240 729.567L238.18 732.751L196.142 659.184L197.961 656ZM194.322 662.367L236.361 735.935L234.541 739.119L192.502 665.551L194.322 662.367ZM190.683 668.735L232.722 742.302L230.902 745.486L188.863 671.919L190.683 668.735ZM187.044 675.102L229.082 748.67L227.263 751.854L185.224 678.286L187.044 675.102ZM183.404 681.47L225.443 755.037L223.624 758.221L181.585 684.654L183.404 681.47ZM179.765 687.837L221.804 761.405L219.984 764.589L177.946 691.021L179.765 687.837ZM176.13 694.205L218.165 767.772L216.345 770.956L174.311 697.389L176.13 694.205ZM172.491 700.572L214.526 774.144L212.71 777.328L170.671 703.756L172.491 700.572ZM168.852 706.94L210.89 780.511L209.071 783.695L167.032 710.123L168.852 706.94ZM165.213 713.307L207.251 786.879L205.432 790.058L163.393 716.491L165.213 713.307Z",
    fill: "url(#paint5_linear_6175_5002)",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_6175_5002",
    x: 144,
    y: 640,
    width: 112,
    height: 172,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_6175_5002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_6175_5002",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6175_5002",
    x1: 1512.44,
    y1: 671.219,
    x2: 1162.34,
    y2: 614.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6175_5002",
    x1: 1933.43,
    y1: 428.862,
    x2: 1427.29,
    y2: 305.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466586,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6175_5002",
    x1: 1431.72,
    y1: 438.175,
    x2: 1271.02,
    y2: 412.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6175_5002",
    x1: 2124.99,
    y1: 618.6,
    x2: 1790.22,
    y2: 548.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6175_5002",
    x1: 336.763,
    y1: 945.578,
    x2: 109.687,
    y2: 908.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A3EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FF4E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6175_5002",
    x1: 242.533,
    y1: 780.207,
    x2: 142.647,
    y2: 764.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#099B91"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6175_5002"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 995,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgFull);
export default __webpack_public_path__ + "static/media/bg_full.235d86d8d3a39b566c35b103e9dfd4cd.svg";
export { ForwardRef as ReactComponent };